export enum ProdutoListaRefinamentoEnum {
    Descricao = 1,
    CodigoSku = 2,
    GtinEan = 3,
    CodigoFornecedor = 4,
    PalavrasChave = 5
}
